export enum SortingHeadersEnum {
 name="name",
 email="email",
 role="role",
 status="status",
 country="country",
 clinicId="clinicId"
}
